<div class="divider"></div>

<div class="action-list">
    <span *ngFor="let item of buttonList">
        <button nz-button
            [nzType]="item.color === 'primary' ? 'primary' : 'default'"
            [nzDanger]="item.color === 'warn'"
            (click)="item.action(data)" class="varbutton" [disabled]="item.disabled">
            <span nz-icon [nzType]="item.icon" *ngIf="item.icon"></span>
            {{ item.description | translateTA }}
        </button>
    </span>
</div>
